<div class="tax-container">
    <header>
        <nav-bar></nav-bar>
        <div class="header-wrapper">
            <div class="banner-wrapper">
                <div class="banner">
                    <div class="intro-block">
                        <p class="title">{{disclaimerTitle}}</p>
                        <p class="sub-title">Tax Certification Portal</p>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <main id="main">
        <div class="content-wrapper">
            <div class="content">
                <article class="main">
                    <div class="project-block">
                        <div class="project">
                            <div class="project-image">
                                <img src="{{dislaimerLogoUrl}}" />
                            </div>
                        </div>
                        <div class="project-details">
                            <h1>Disclaimer</h1>
                            <div class="intro-text" [innerHTML]="disclaimerIntro"></div>
                            <h2>Are You a Person?</h2>
                            <p>This website is professionally hosted and operates in a secure environment. However, being in the Internet, this website may be exposed to third parties with malicious intent. As an extra security measure, this website security code has been added - this is known as a CAPTCHA (<b>A</b>utomated <b>P</b>ublic <b>T</b>uring test to tell <b>C</b>omputers and <b>H</b>umans <b>A</b>part).</p>

                            <div class="captcha-section">
                                <form [formGroup]="frmDisclaimer" (submit)="submitAgree()">

                                    <img src="{{imgCaptchaSource}}" class="captcha" />
                                    <div class="form-input-group">
                                        <div class="form-input">
                                            <label for="confirmCaptchaCode">Security Code <cite>*</cite></label>
                                            <div class="e-input-group">
                                                <input class="e-input" name='confirmCaptchaCode' formControlName="confirmCaptchaCode" type="text"
                                                       (focus)="focusIn($event.target)" (blur)="focusOut($event.target)"
                                                       placeholder="Enter security code" maxlength="5" />
                                            </div>
                                            <validator [controlToValiddate]="'confirmCaptchaCode'" [errorCollection]="errorCollection"></validator>
                                        </div>
                                    </div>
                                    <div class="button-area">
                                        <div class="buttons-left">
                                            <div>
                                                <button ejs-button class="e-primary e-bigger" iconCss="e-icons e-chevron-right-icon" iconPosition="Right">Complete Online Tax Certification</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    </main>
    <footer-bar></footer-bar>
</div>
